define(["document-ready-promise", "jquery"], function (ready, $) {
    var co2Swiper = null;
    var co2SwiperPauseReasons = {};

    var home = {
        numSchoolsAnimated: false,

        init: function () {
            this.initialiseHomeIntroCarousel();
            home.scaleSlideImages();
            home.initPopovers();
        },

        scaleSlideImages: function () {
            var heights = [];
            $(".swiper-slide .slide-content").each(function (index) {
                heights.push($(this).outerHeight());
            });
            var slideHeight = Math.max(...heights);
            $(".swiper-slide .slide-content").height(slideHeight);
        },

        initialiseHomeIntroCarousel: function () {
            co2Swiper = new Swiper("#pilot-swiper", {
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                // Optional parameters
                direction: "horizontal",
                loop: true,
                speed: 800,

                // If we need pagination
                spaceBetween: 2,
                grabCursor: false,
                pagination: ".swiper-pagination",
                paginationClickable: true,
                bulletActiveClass: "bg-primary opacity-full",
                watchSlidesProgress: true,
                autoplay: 5000,
                autoplayDisableOnInteraction: false
            });

            $("#home-intro-swiper").hover(
                function () {
                    home.carouselPause("hover");
                },
                function () {
                    home.carouselResume("hover");
                }
            );

            co2Swiper.on("onProgress", function () {
                home.carouselResume();
            });
        },

        carouselPause: function (reason) {
            co2Swiper.stopAutoplay();

            if (reason) {
                co2SwiperPauseReasons[reason] = true;
            }
        },

        carouselResume: function (reason) {
            if (reason) {
                delete co2SwiperPauseReasons[reason];
            } else {
                co2SwiperPauseReasons = {};
            }

            if (!Object.keys(co2SwiperPauseReasons).length) {
                $(".info-panel-body").addClass("hidden");
                co2Swiper.startAutoplay();
            }
        }
    };

    ready().then(function () {
        home.init();
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/pilot/pilot.js